/* eslint-disable camelcase */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import map from 'lodash/map';
import find from 'lodash/find';
import sortBy from 'lodash/sortBy';
import reverse from 'lodash/reverse';
import mapKeys from 'lodash/mapKeys';
import forEach from 'lodash/forEach';
// import debounce from 'lodash/debounce';
import styled from 'styled-components';
import {
  Dropdown,
  Divider,
  Grid,
  Container,
  Loader,
  Button,
  Segment,
  Header
} from 'semantic-ui-react';
import { toast, ToastContainer } from 'react-toastify';
import { getAccounts } from '../../services/AccountService';
import { getCampaigns, getCampaign } from '../../fbApi/Campaign';
import { getAds } from '../../fbApi/Ad';
import { clearFbCacheInLocalStorage } from '../../fbApi/fbCallManager';
import * as AppActions from '../../actions';
import months from '../../utils/months';
import { updateUrl } from '../../utils/urls';
import SharePresentationEmail from './PresentationComponents/SharePresentationEmail';
import TabCampaignsComponent from './PresentationComponents/TabCampaignsComponent';
import { retrieveAllAdsInfo, getUtms } from '../../services/AdServiceManager';

import './PresentationBuilder.css';

const ProcessingErrorText = styled.h3`
  text-align: center;
  padding-top: 100px;
`;

class PresentationBuilder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      utms: {},
      data: null,
      showMonthSelector: false,
      showYearSelector: false,
      accounts: null,
      showMonthLoader: false,
      showYearLoader: false,
      doneLoading: false,
      accountOptions: null,
      adAccountName: null,
      adAccountId: null,
      campaignIds: [],
      campaignMonthName: '',
      selectedYear: '',
      selectedAccounts: [],
      campaignId: null,
      campaignName: {
        PRODUCT_CATALOG_SALES: null,
        LEAD_GENERATION: null,
        VIDEO_VIEWS: null,
        LINK_CLICKS: null,
        CONVERSIONS: null,
        REACH: null,
        MESSAGES: null,
        POST_ENGAGEMENT: null,
        OUTCOME_TRAFFIC: null,
        OUTCOME_SALES: null
      },
      campaignObjective: null,
      selectedCampaigns: '',
      campaignMonth: {
        PRODUCT_CATALOG_SALES: [],
        LEAD_GENERATION: [],
        VIDEO_VIEWS: [],
        LINK_CLICKS: [],
        CONVERSIONS: [],
        REACH: [],
        MESSAGES: [],
        POST_ENGAGEMENT: [],
        OUTCOME_TRAFFIC: [],
        OUTCOME_SALES: []
      },
      campaigns: [],
      years: [],
      previews: [],
      token: props.getFbToken(),
      processing: true,
      processingError: false,
      adElementId: '',
      sorting: 'type',
      campaignTagsObjects: [],
      ProductCatUrls: [],
      LeadGenUrls: [],
      VideoViews: [],
      LinkClickUrls: [],
      ConversionsUrls: [],
      refreshAccountsLoading: false
    };
  }

  componentDidMount() {
    // check for existing cached presentation for this campaign / month
    const { setSectionTitle, saveGTMEvent } = this.props;
    this.loadUtms();
    setSectionTitle('Ad Preview');
    saveGTMEvent('Ad Preview', 'Ad Preview');
    this.getAdAccounts().then(() => {
      this.preSelectFields().then(() => {
        this.setState({ processing: false }, () => {
          this.expandAllAdsOnMount();
        });
      });
    });
    // document
    //   .querySelector('.App-content')
    //   .addEventListener('scroll', debounce(this.handleScroll, 300));
  }

  expandAllAdsOnMount = () => {
    const url = window.location.href;
    const urlParts = url.split('#');

    if (!urlParts[1]) {
      return;
    }

    const params = urlParts[1].split('&');
    const showAllParam = find(params, (p) => p && p.indexOf('showAll=') !== -1);
    if (showAllParam) {
      const showAllValue = showAllParam
        .split('=')[1]
        .replace(new RegExp('%20', 'g'), ' ');
      const noExpand = !showAllValue || showAllValue === 'false';
      if (!noExpand) {
        this.props.actions.expandAll();
      }
    }
  };

  componentWillUnmount() {
    // document
    //   .querySelector('.App-content')
    //   .removeEventListener('scroll', debounce(this.handleScroll, 300));
  }

  shouldComponentUpdate(nextProps) {
    const { showCheckboxesMultiQc, showCheckboxes } = this.props;
    const {
      showCheckboxesMultiQc: nextshowCheckboxesMultiQc,
      showCheckboxes: nextShowCheckboxes
    } = nextProps;

    if (
      showCheckboxes !== nextShowCheckboxes ||
      showCheckboxesMultiQc !== nextshowCheckboxesMultiQc
    ) {
      return false;
    }
    return true;
  }

  refreshAccounts = () => {
    clearFbCacheInLocalStorage();
    this.setState(
      (prevState) => ({
        ...prevState,
        refreshAccountsLoading: true
      }),
      async () => {
        await this.getAdAccounts();
        await this.preSelectFields();
        this.setState((...prevState) => ({
          ...prevState,
          processing: false,
          refreshAccountsLoading: false
        }));
      }
    );
  };

  loadUtms = async () => {
    const response = await getUtms();
    const { data } = response;
    const { utms: utmsFromData } = data || {};
    const utms = {};
    if (utmsFromData && utmsFromData.length > 0) {
      utmsFromData.forEach((utm) => {
        utms[utm.name] = utm;
      });
    }
    this.setState((prevState) => ({ ...prevState, utms }));
  };

  onAccountSelect = async (event, { options, value }) => {
    const accountOption = find(options, (option) => option.value === value);
    const accountId = accountOption.value;
    const accountName = accountOption.text;
    updateUrl(accountName, '', '', '', '', '');
    await this.selectAccount(accountId, accountName);
  };

  onYearSelect = (event, data) => {
    const value = data.value;
    updateUrl(this.state.adAccountName, value, '', '', '', '');
    this.selectYear(value);
  };

  onMonthSelect = (event, data) => {
    // get Campaigns, then get ads
    const n = find(data.options, (o) => o.value === data.value);
    const ids = n.value.split(',');
    // sends a campaign id, gets back all ads, with adSet info
    const monthYear = n.text;
    updateUrl(
      this.state.adAccountName,
      this.state.selectedYear,
      monthYear,
      '',
      '',
      ''
    );
    this.setState(
      {
        ProductCatUrls: [],
        LeadGenUrls: [],
        VideoViews: [],
        LinkClickUrls: [],
        ConversionsUrls: []
      },
      () => {
        this.selectMonth(ids, monthYear);
      }
    );
  };

  getAdAccounts = async () => {
    try {
      const result = await getAccounts(this.props.user.groups[0]);

      const accountOptions = sortBy(
        map(result, (op, index) => ({
          key: index,
          value: op.account_id,
          text: op.name
        })),
        'text'
      );

      this.setState({
        data: result,
        accounts: sortBy([...result], 'name'),
        accountOptions
      });
    } catch (error) {
      console.log(error);
    }
  };

  getCampaigns = async (id) => {
    try {
      // this.setState({ campaigns: [], previews: [], showYearLoader: true });
      const screen = 'Ad Preview';
      const campaigns = await getCampaigns(id, this.state.token, screen);
      const result = campaigns.data;

      const assocCampaigns = [];
      const campaignMonths = [];
      const years = [];

      map(reverse(sortBy([...result], 'start_time')), (campaign) => {
        const firstPart = campaign.name.split('_')[0];
        const year =
          firstPart.length === 4
            ? firstPart
            : firstPart.substring(firstPart.length - 4, firstPart.length);
        const month =
          firstPart.length === 4
            ? campaign.name.split('_')[1]
            : firstPart.substring(0, firstPart.length - 4);
        assocCampaigns[year + month] = {
          month_year: null,
          ids: []
        };
      });

      map(reverse(sortBy([...result], 'start_time')), (campaign) => {
        const firstPart = campaign.name.split('_')[0];
        const year =
          firstPart.length === 4
            ? firstPart
            : firstPart.substring(firstPart.length - 4, firstPart.length);
        const month =
          firstPart.length === 4
            ? campaign.name.split('_')[1]
            : firstPart.substring(0, firstPart.length - 4);

        const existentYear = years.filter((item) => item.text === year);

        if (existentYear.length === 0) {
          years.push({
            value: year,
            text: year
          });
        }

        assocCampaigns[year + month].month = month;
        assocCampaigns[year + month].year = year;
        assocCampaigns[year + month].ids.push(campaign.id);
      });

      mapKeys(assocCampaigns, (assocCampaign) => {
        if (assocCampaign) {
          campaignMonths.push(assocCampaign);
        }
      });

      const campaignOpts = map(campaignMonths, (op, index) => {
        const month = months.filter((item) => item.shortName === op.month);

        return {
          key: index,
          value: op.ids.join(','),
          text: month[0] ? month[0].monthName : op.month,
          accountId: id,
          year: op.year
        };
      });

      this.setState({
        data: result,
        campaigns: campaignOpts,
        filteredCampaigns: campaignOpts,
        showYearSelector: true,
        showYearLoader: false,
        years
      });

      return campaignOpts;
    } catch (error) {
      console.log(error);
    }
    return null;
  };

  getAds = async (ids) => {
    const { token, campaignMonth } = this.state;
    const { actions } = this.props;
    const allCampaigns = await Promise.all(
      map(ids, async (id) => {
        const campaign = await getCampaign(id, token);

        const campaignObjective = campaign.objective;
        const cn = this.state.campaignName;
        cn[campaignObjective] = campaign.name.replace(/_/g, ' ');
        this.setState({ campaignName: cn });
        const resultAds = await getAds(campaign.id, token);

        let ads = [];
        if (resultAds.error) {
          this.setState({ processingError: true });
        } else {
          ads = resultAds.data;
        }
        const previewObjects = ads.map(async (ad) => ({
          ...ad,
          ad_id: ad.id,
          name: ad.name,
          campaignObjective,
          creative: ad.creative,
          destination_url: ad.creative.object_story_spec
        }));
        return Promise.all(previewObjects);
      })
    );

    const selectedAds = {
      LINK_CLICKS: [],
      VIDEO_VIEWS: [],
      LEAD_GENERATION: [],
      PRODUCT_CATALOG_SALES: [],
      CONVERSIONS: [],
      REACH: [],
      MESSAGES: [],
      POST_ENGAGEMENT: [],
      OUTCOME_TRAFFIC: [],
      OUTCOME_SALES: []
    };
    const qcProcess = {
      LINK_CLICKS: {
        totalAds: 0,
        totalQC: 0
      },
      VIDEO_VIEWS: {
        totalAds: 0,
        totalQC: 0
      },
      LEAD_GENERATION: {
        totalAds: 0,
        totalQC: 0
      },
      PRODUCT_CATALOG_SALES: {
        totalAds: 0,
        totalQC: 0
      },
      CONVERSIONS: {
        totalAds: 0,
        totalQC: 0
      },
      REACH: {
        totalAds: 0,
        totalQC: 0
      },
      MESSAGES: {
        totalAds: 0,
        totalQC: 0
      },
      POST_ENGAGEMENT: {
        totalAds: 0,
        totalQC: 0
      },
      OUTCOME_TRAFFIC: {
        totalAds: 0,
        totalQC: 0
      },
      OUTCOME_SALES: {
        totalAds: 0,
        totalQC: 0
      }
    };

    let videoAds = [];
    let dynamicAds = [];
    let siteVisits = [];
    // to do: refactor this garbage code
    forEach(allCampaigns, (campaign) => {
      // console.log("foreach AllCampaigns - campaign", campaign);
      // console.log("campaignMonth", campaignMonth);
      const { ProductCatUrls, VideoViews, ConversionsUrls } = this.state;
      let campaignObjective = '';
      if (campaign && campaign[0]) {
        campaignObjective = campaign[0].campaignObjective;
      }
      // console.log("campaignObjective", campaignObjective.trim());
      // console.log("campaignMonth[campaignObjective]", campaignMonth[campaignObjective]);
      if (campaignObjective.trim() !== '' && campaignMonth[campaignObjective]) {
        campaignMonth[campaignObjective] = campaignMonth[
          campaignObjective
        ].concat(campaign);
        selectedAds[campaignObjective] = selectedAds[campaignObjective].concat(
          campaign.map((ad) => ({
            id: ad.ad_id,
            name: ad.name,
            creative: ad.creative
          }))
        );
        videoAds = [];
        dynamicAds = [];
        siteVisits = [];
        for (let i = 0; i < campaign.length; i += 1) {
          // console.log("iterate through campaigns", i);
          const { creative, ad_id } = campaign[i];
          const { object_story_spec } = creative || {};
          const { link_data, template_data, video_data } =
            object_story_spec || {};

          if (link_data) {
            const { child_attachments } = link_data;
            if (child_attachments != null) {
              const carouselUrls = [];
              for (let j = 0; j < child_attachments.length; j += 1) {
                const { link } = child_attachments[j];
                carouselUrls.push(link);
              }
              const currAd = {
                ad_id,
                ad_url: carouselUrls
              };
              siteVisits.push(currAd);
            } else {
              const { link } = link_data || {};
              const currAd = {
                ad_id,
                ad_url: link
              };
              siteVisits.push(currAd);
            }
          } else if (template_data) {
            const { link } = template_data || {};
            const currAd = {
              ad_id,
              ad_url: link
            };
            dynamicAds.push(currAd);
          } else if (video_data) {
            const { call_to_action } = video_data || {};
            const { value } = call_to_action || {};
            const { link } = value || {};
            const currAd = {
              ad_id,
              ad_url: link
            };
            videoAds.push(currAd);
          }
        }

        if (videoAds !== []) {
          videoAds.concat(VideoViews);
        }

        if (dynamicAds !== []) {
          dynamicAds.concat(ProductCatUrls);
        }

        if (siteVisits !== []) {
          siteVisits.concat(ConversionsUrls);
        }
        qcProcess[campaignObjective].totalAds =
          selectedAds[campaignObjective].length;
      }
    });

    actions.initCampaignTotalAds(qcProcess);

    const allIds = [];
    Object.keys(selectedAds).forEach((o) => {
      selectedAds[o].forEach((ad) => allIds.push(ad.id));
    });
    const allAdsInfo = await retrieveAllAdsInfo(allIds.join(','));
    this.setState({
      doneLoading: true,
      showAdsLoading: false,
      campaignMonth,
      allAdsInfo: allAdsInfo.ads,
      processing: false,
      VideoViews: videoAds,
      ProductCatUrls: dynamicAds,
      ConversionsUrls: siteVisits
    });
  };

  preSelectFields = async () => {
    const { actions } = this.props;
    const url = window.location.href;
    const urlParts = url.split('#');

    if (!urlParts[1]) {
      return;
    }

    const params = urlParts[1].split('&');
    const selectedAccount = find(
      params,
      (p) => p && p.indexOf('account=') !== -1
    );

    if (selectedAccount) {
      const accountValue = selectedAccount
        .split('=')[1]
        .replace(new RegExp('%20', 'g'), ' ');
      if (!accountValue) return;
      const account = find(
        this.state.accounts,
        (a) => a.name && a.name.indexOf(accountValue) !== -1
      );

      if (account) {
        const campaigns = await this.selectAccount(
          account.account_id,
          account.name
        );
        const selectedYear = find(
          params,
          (p) => p && p.indexOf('year=') !== -1
        );

        if (selectedYear) {
          const yearValue = selectedYear
            .split('=')[1]
            .replace(new RegExp('%20', 'g'), ' ');
          if (!yearValue) return;
          this.selectYear(yearValue);
          const selectedMonth = find(
            params,
            (p) => p && p.indexOf('month=') !== -1
          );

          if (selectedMonth) {
            const monthValue = selectedMonth
              .split('=')[1]
              .replace(new RegExp('%20', 'g'), ' ');
            if (!monthValue) return;
            const month = find(
              campaigns,
              (c) => c.text && c.text === monthValue
            );
            const ids = month.value.split(',');
            this.selectMonth(ids, month.text);
          }

          const selectedAccordionIndex = find(
            params,
            (p) => p && p.indexOf('ad=') !== -1
          );
          const selectedCampaignKey = find(
            params,
            (p) => p && p.indexOf('campaign=') !== -1
          );

          if (selectedCampaignKey) {
            const accordionIndex = selectedAccordionIndex
              .split('=')[1]
              .replace(new RegExp('%20', 'g'), ' ');
            const campaignKey = selectedCampaignKey
              .split('=')[1]
              .replace(new RegExp('%20', 'g'), ' ');

            if (accordionIndex) {
              // actions.adPreviewAdAccordionIndex(
              //   parseInt(accordionIndex, 10),
              //   campaignKey
              // );
              actions.adPreviewAdAccordionIndex(-1, campaignKey);
              this.setState({
                adElementId: `#accordion-${accordionIndex}-${campaignKey}`
              });
            }
          }
        }
      }
    }
  };

  scrollToAccordion = () => {
    if (this.state.adElementId) {
      const adElement = document.querySelector(this.state.adElementId);
      if (adElement) {
        adElement.scrollIntoView({
          block: 'start',
          behavior: 'smooth'
        });
      }
    }
  };

  selectAccount = async (accountId, accountName) => {
    const utmsWithAccountsFiltered = this.filterUtms(accountId);
    // the rest of ad preview uses an array for selectedAdAccounts
    // to prevent anything from breaking, selectedAccounts has been left as an array.
    const newSelectedAccounts = [{ value: accountId, name: accountName }];
    this.setState((prevState) => ({
      ...prevState,
      utms: utmsWithAccountsFiltered,
      selectedAccounts: newSelectedAccounts,
      selectedYear: '',
      adAccountId: accountId,
      adAccountName: accountName,
      doneLoading: false,
      showMonthSelector: false,
      showAdsLoading: false,
      showDropdownLoading: false,
      campaignMonth: {
        PRODUCT_CATALOG_SALES: [],
        LEAD_GENERATION: [],
        VIDEO_VIEWS: [],
        LINK_CLICKS: [],
        CONVERSIONS: [],
        REACH: [],
        MESSAGES: [],
        POST_ENGAGEMENT: [],
        OUTCOME_TRAFFIC: [],
        OUTCOME_SALES: []
      },
      campaigns: []
    }));

    const campaigns = await this.getCampaigns(accountId);

    return Promise.resolve(campaigns);
  };

  filterUtms = (accountId) => {
    const { utms } = this.state;
    const utmKeys = Object.keys(utms);
    const filteredUtms = {};

    utmKeys.forEach((key) => {
      const currentUtm = utms[key];
      const { accounts } = currentUtm;
      let includeUtm = !accounts || accounts.length <= 0;
      if (accounts.length > 0) {
        const foundAccountIndex = accounts.findIndex((accountObj) => {
          const { accountId: currentId } = accountObj;
          return currentId === accountId;
        });
        includeUtm = foundAccountIndex !== -1;
      }
      if (includeUtm) filteredUtms[key] = currentUtm;
    });
    return filteredUtms;
  };

  selectYear = (value) => {
    const { campaigns } = this.state;
    const filteredCampaigns = campaigns.filter((val) => val.year === value);
    this.setState({
      ...this.state,
      showMonthSelector: true,
      showMonthLoader: false,
      filteredCampaigns,
      selectedYear: value,
      doneLoading: false,
      showAdsLoading: false,
      showDropdownLoading: false,
      selectedCampaigns: '',
      previews: [],
      shareLink: null,
      campaignMonth: {
        PRODUCT_CATALOG_SALES: [],
        LEAD_GENERATION: [],
        VIDEO_VIEWS: [],
        LINK_CLICKS: [],
        CONVERSIONS: [],
        REACH: [],
        MESSAGES: [],
        POST_ENGAGEMENT: [],
        OUTCOME_TRAFFIC: [],
        OUTCOME_SALES: []
      }
    });
  };

  selectMonth = (ids, monthYear) => {
    const { selectedAccounts, selectedYear, data } = this.state;
    const campaignData = data || [];
    const accountId = selectedAccounts[0].value;
    const campaignTagObjectsForAllAdsInMonth = [];
    const monthAbbreviation = monthYear.substring(0, 3);

    const filteredCampaigns = campaignData.filter((campaign) => {
      const { name } = campaign;
      return name.includes(selectedYear) && name.includes(monthAbbreviation);
    });
    filteredCampaigns.forEach((campaign) => {
      const {
        id,
        name,
        objective,
        special_ad_categories: specialAdCat
      } = campaign;
      const campaignTagsObject = {
        campaignId: id,
        campaignName: name,
        campaignObjective: objective,
        campaignSpecialAdCat: specialAdCat || 'NONE'
      };

      if (campaign.adlabels) {
        campaignTagsObject.campaignTags = campaign.adlabels;
      }

      campaignTagObjectsForAllAdsInMonth.push(campaignTagsObject);
    });

    this.setState(
      (prevState) => ({
        ...prevState,
        previews: [],
        doneLoading: false,
        shareLink: null,
        campaignMonth: {
          PRODUCT_CATALOG_SALES: [],
          LEAD_GENERATION: [],
          VIDEO_VIEWS: [],
          LINK_CLICKS: [],
          CONVERSIONS: [],
          REACH: [],
          MESSAGES: [],
          POST_ENGAGEMENT: [],
          OUTCOME_TRAFFIC: [],
          OUTCOME_SALES: []
        },
        campaignIds: ids,
        showAdsLoading: true,
        campaign_ids: [{ value: ids, text: monthYear, accountId }],
        campaignMonthName: monthYear,
        selectedCampaigns: ids.join(','),
        campaignTagsObjects: campaignTagObjectsForAllAdsInMonth,
        presentationSaved: null,
        processing: true,
        adTabActiveIndex: [],
        accordionIndex: {
          LINK_CLICKS: -1,
          VIDEO_VIEWS: -1,
          LEAD_GENERATION: -1,
          PRODUCT_CATALOG_SALES: -1,
          CONVERSIONS: -1,
          REACH: -1,
          MESSAGES: -1,
          POST_ENGAGEMENT: -1,
          OUTCOME_TRAFFIC: -1,
          OUTCOME_SALES: -1
        }
      }),
      () => {
        this.getAds(ids);
      }
    );
  };

  // handleScroll = () => {
  //   const { expandAll, isScrolling, actions } = this.props;
  //   const { adAccountName, selectedYear, campaignMonthName } = this.state;
  //   if (expandAll) {
  //     for (const item of document.querySelectorAll(
  //       '.campaigns-container .active .accordion-item'
  //     )) {
  //       const rect = item.getBoundingClientRect();
  //       const offsetHeight = item.offsetHeight * -1;

  //       if (rect.top > offsetHeight && rect.top <= 100) {
  //         const parts = item.getAttribute('id').split('-');
  //         updateUrl(
  //           adAccountName,
  //           selectedYear,
  //           campaignMonthName,
  //           parts[1],
  //           parts[2],
  //           ''
  //         );
  //       }
  //     }
  //     const appScrollTop = document.querySelector('.App-content').scrollTop;
  //     if (appScrollTop <= 1) {
  //       updateUrl(adAccountName, selectedYear, campaignMonthName, '', '', '');
  //     }
  //   }

  //   if (!isScrolling) {
  //     actions.adPreviewScrolling(true);
  //     setTimeout(() => {
  //       actions.adPreviewScrolling(false);
  //     }, 200);
  //   }
  // };

  resetState = () => {
    this.setState({
      previews: [],
      doneLoading: false,
      shareLink: null,
      campaignMonth: {
        PRODUCT_CATALOG_SALES: [],
        LEAD_GENERATION: [],
        VIDEO_VIEWS: [],
        LINK_CLICKS: [],
        CONVERSIONS: [],
        REACH: [],
        MESSAGES: [],
        POST_ENGAGEMENT: [],
        OUTCOME_TRAFFIC: [],
        OUTCOME_SALES: []
      }
    });
  };

  renderYearDropdown = (years) => {
    const {
      showYearSelector,
      processing,
      selectedYear,
      showYearLoader
    } = this.state;
    if (showYearSelector) {
      return (
        <Dropdown
          disabled={processing}
          placeholder="Year"
          search
          selection
          value={selectedYear}
          options={years}
          onChange={this.onYearSelect}
        />
      );
    } else if (showYearLoader) {
      return (
        <Container>
          <Loader inline className="active" />
        </Container>
      );
    }
    return null;
  };

  renderMonthDropdown = (filteredCampaigns) => {
    const {
      showMonthSelector,
      processing,
      selectedCampaigns,
      showMonthLoader
    } = this.state;
    if (showMonthSelector) {
      return (
        <Dropdown
          placeholder="Month"
          search
          selection
          disabled={processing}
          value={selectedCampaigns}
          options={filteredCampaigns}
          onChange={this.onMonthSelect}
        />
      );
    } else if (showMonthLoader) {
      return (
        <Container>
          <Loader inline className="active" />
        </Container>
      );
    }
    return null;
  };

  renderError = () => {
    const { processingError } = this.state;
    if (processingError) {
      return (
        <ProcessingErrorText>
          There was an issue loading up the Ads from Facebook. Please try again
          later.
        </ProcessingErrorText>
      );
    }

    return null;
  };

  setSortingState = (newSortingCriteria) => {
    toast(`Ads sorted by ${newSortingCriteria}`, {
      position: 'bottom-center',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
    });
    this.setState({ sorting: newSortingCriteria });
  };

  forceFamilyUpdate = () => {
    const { allAdsInfo } = this.state;
    const allAdIds = allAdsInfo.map((adsInfo) => {
      return adsInfo.adId;
    });
    retrieveAllAdsInfo(allAdIds.join(',')).then((result) => {
      this.setState({
        allAdsInfo: result.ads
      });
    });
  };

  // this function is used to get fb ad previews and set the preview urls
  // I left this in case we need to revert changes
  // getFilledAdsFromTabCampaigns = async (selectedAds) => {
  //   const { token } = this.state;
  //   const campaignObjectives = Object.keys(selectedAds);
  //   const newSelectedAds = {};

  //   await Promise.all(
  //     campaignObjectives.map(async (campaignObjective) => {
  //       const adsWithPreviews = await Promise.all(
  //         selectedAds[campaignObjective].map(async (selectedAd) => {
  //           const ad = selectedAd;
  //           const { id, name, facebookInfo } = ad;
  //           let ad_link = null;
  //           if (facebookInfo) {
  //             ad_link = facebookInfo.ad_link;
  //           }
  //           const adForPreview = {
  //             id,
  //             name,
  //             campaign: {
  //               objective: campaignObjective
  //             }
  //           };
  //           const isCanvas = ad_link
  //             ? ad_link.split('canvas_doc').length > 1
  //             : false;
  //           if (!ad.urls.desktopUrl || !ad.urls.mobileUrl) {
  //             const preview = await getPreviews(
  //               adForPreview,
  //               token,
  //               isCanvas,
  //               adForPreview.name.split('Collection').length > 1
  //             );
  //             ad.urls.desktopUrl = preview.desktop;
  //             ad.urls.mobileUrl = preview.mobile;
  //           }
  //           return Promise.resolve(ad);
  //         })
  //       );

  //       newSelectedAds[campaignObjective] = adsWithPreviews;
  //     })
  //   );

  //   return Promise.resolve(newSelectedAds);
  // };

  render() {
    const {
      accountOptions,
      years,
      filteredCampaigns,
      campaignMonth,
      processing,
      adAccountId,
      campaignMonthName,
      selectedAccounts,
      adAccountName,
      selectedYear,
      campaign_ids,
      doneLoading,
      showAdsLoading,
      processingError,
      sorting,
      allAdsInfo,
      utms,
      campaignTagsObjects,
      ProductCatUrls,
      LeadGenUrls,
      VideoViews,
      LinkClickUrls,
      ConversionsUrls,
      refreshAccountsLoading
    } = this.state;
    const { getFbToken } = this.props;
    return (
      <div className="container" onScroll={this.handleScroll}>
        <Grid>
          <Grid.Row columns={4}>
            <Grid.Column>
              <Dropdown
                placeholder="Ad Accounts"
                search
                selection
                disabled={processing}
                value={adAccountId}
                options={accountOptions}
                onChange={this.onAccountSelect}
              />
              <Button
                basic
                compact
                loading={refreshAccountsLoading}
                color="blue"
                icon="refresh"
                onClick={this.refreshAccounts}
                style={{ marginLeft: '2%' }}
              />
              <Divider hidden />
              {this.renderYearDropdown(years)}
              <Divider hidden />
              {this.renderMonthDropdown(filteredCampaigns)}
            </Grid.Column>
            <Grid.Column />
            <Grid.Column />
            <Grid.Column>
              {doneLoading && !showAdsLoading ? (
                <div>
                  <Segment attached="top" textAlign="center">
                    <Header as="h3" textAlign="center">
                      Share
                    </Header>
                  </Segment>
                  <Segment attached>
                    <SharePresentationEmail
                      campaignMonth={campaignMonth}
                      campaignMonthName={campaignMonthName}
                      selectedAccounts={selectedAccounts}
                      adAccountName={adAccountName}
                      selectedYear={selectedYear}
                      campaign_ids={campaign_ids}
                      adAccountUrls={ProductCatUrls.concat(LeadGenUrls)
                        .concat(VideoViews)
                        .concat(LinkClickUrls)
                        .concat(ConversionsUrls)}
                      selectedProd={ProductCatUrls}
                      selectedLead={LeadGenUrls}
                      selectedVideo={VideoViews}
                      selectedLink={LinkClickUrls}
                      selectedConv={ConversionsUrls}
                      showAdsLoading={showAdsLoading}
                      // getFilledAdsFromTabCampaigns={
                      //   this.getFilledAdsFromTabCampaigns
                      // }
                    />
                  </Segment>
                </div>
              ) : null}
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Divider hidden />
        <ToastContainer />
        {!doneLoading && showAdsLoading ? <Loader className="active" /> : null}
        {processingError && this.renderError()}
        {doneLoading && !processingError && (
          <div style={{ width: '100%', height: '100%' }}>
            <Divider />
            <TabCampaignsComponent
              campaignMonth={campaignMonth}
              sorting={sorting}
              setSortingState={this.setSortingState}
              getFbToken={getFbToken}
              allAdsInfo={allAdsInfo}
              campaignMonthName={campaignMonthName}
              selectedAccounts={selectedAccounts}
              adAccountName={adAccountName}
              selectedYear={selectedYear}
              campaign_ids={campaign_ids}
              scrollToAccordion={this.scrollToAccordion}
              utms={utms}
              setUpdateUrl
              forceFamilyUpdate={this.forceFamilyUpdate}
              campaignTagsObjects={campaignTagsObjects}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { adPreview, user } = state;
  const {
    selectedAds,
    checkedCampaigns,
    indeterminateCampaigns,
    isScrolling,
    expandAllAds: expandAll,
    showCheckboxes,
    showCheckboxesMultiQc
  } = adPreview;
  return {
    user,
    selectedAds,
    checkedCampaigns,
    indeterminateCampaigns,
    isScrolling,
    expandAll,
    showCheckboxes,
    showCheckboxesMultiQc
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PresentationBuilder);



// WEBPACK FOOTER //
// ./src/screens/Presentation/PresentationBuilder.js